import { RunSettings } from "../services/appsync/types";

export const runSettinsToId = (runSettings: RunSettings) => {
  return `${runSettings.inputId}-${runSettings.organizationId}-${runSettings.workflowId}-${runSettings.settingsNameAndVersion}-${runSettings.runAttemptId}`;
};
